import React, { memo } from 'react';
import ReactAvatar from 'react-avatar';
import classNames from 'classnames';
import placeholder from './assets/placeholder.png';
import classes from './Avatar.module.scss';

function Avatar({
  photoUrl,
  onClick,
  size = 32,
  className,
  isActive,
  enableHoverBorder = false,
  ...otherProps
}) {
  const src = photoUrl || placeholder;

  const customClasses = classNames(
    className,
    enableHoverBorder && classes.avatar,
    isActive && enableHoverBorder && classes['avatar--border'],
  );

  return (
    <ReactAvatar
      round
      src={src}
      size={size}
      onClick={onClick}
      className={customClasses}
      {...otherProps}
    />
  );
}

export default memo(Avatar);
